import React from 'react';
import { Divider, List, Segment } from 'semantic-ui-react'
import FieldModal from "./fieldModal";
import { Descriptor } from '../../../../../../../models/descriptorModel';
import { DescriptorView, Option } from './descriptorView'
import ConfirmationModal from '../../../../../../../components/confirmationModal';
import DescriptorOps from './utils/descriptorOps';
import MoveToModal from './moveToModal';
import MoveBellowModal from './moveBellowModal'
import Alert from '../../../../../../../utils/alert';
import Utils from '../../../../../../../utils/descriptor/descriptorUtils';
import PropTypes from 'prop-types'
import { DescriptorColors, SchemaField } from '../../../../../../../constnats/schemaConstants';
import { DescriptorProps } from '../../../../../../../constnats/descriptor';
import { isStandardizedLabelRequired, isCategorizationRequired } from '../../../../../../../utils/categorization/common';
import { CssProps } from '../../../../../../../constnats/css';
import DescriptorType from '../../../../../../../utils/descriptor/descriptorType';
import { TextFiedSpec, SelectFiedSpec, CustomFieldSpec, CheckboxFieldSpec, FormSection } from '../../../../../../../utils/htmlFieldsFactory';
import { DESCRIPTOR_TYPES_MAP, IMPORTANCE_MAP, validateDataCalcType, DATA_CALC_TYPES_MAP, numFieldsDisabled, validateIScale, validateVScale, SCALE_MAP, validationScalable, getCalcFieldCfgSpec, primaryCalcDisabled, validatePrimaryCalc, secondaryCalcDisabled, validateSecondaryCalc, CategoriesSectionField, InputScaleSelectionField, StandardizedLabelRelationSectionField, TimeframeSectionField } from './utils/fieldModalUtils';
import StandardizedLabelsRepo from '../../../../../../../utils/repository/standardizedLabelsRepo/standardizedLabelsRepo';
import { RESPONSE_STATUS } from '../../../../../../../constnats/general';
import { TIMEFRAME_PERIOD } from '../../../../../../../constnats/timeframe';
import SortableDescriptorList from './components/sortableDescriptorList';
import SortableDescriptorItem from './components/sortableDescriptorItem';
import OutgoingBridgesField from './components/outgoingBridgesField';
import { getDescriptorBridges, getOutgoingBridges } from '../../../../../../../utils/descriptor/outgoingBridges';
import { outgoingBridgesSchema } from '../../../../../../../schemas/outgoingBridge.schemas';

const FORM_SPEC = {
    fields: [
        new TextFiedSpec(DescriptorProps.LABEL),
        new SelectFiedSpec(DescriptorProps.TYPE, { customStaticProps: { placeholder: "Type" } },
             DESCRIPTOR_TYPES_MAP),
        new SelectFiedSpec(DescriptorProps.IMPORTANCE, {}, IMPORTANCE_MAP),
        new CustomFieldSpec(
            DescriptorProps.STANDARDIZED_LABEL_RELATION,
            {
                dynamicPropsProvider: (context) => ({
                    descriptorId: context.descriptor.id,
                    schemaId: context.schemaId,
                    usedStandardizedLabels: context.usedStandardizedLabels,
                }),
                checkDisabled: ({ descriptor }) => DescriptorType.isHeadline(descriptor),
            },
            StandardizedLabelRelationSectionField,
        ),
        new CustomFieldSpec(
            DescriptorProps.TIMEFRAME,
            {
                dynamicPropsProvider: (context) => ({
                    descriptorId: context.descriptor.id,
                    flatDescriptors: context.flatDescriptors,
                }),
            },
            TimeframeSectionField,
        ),
        new CustomFieldSpec(DescriptorProps.CATEGORY,
            {
                valueProp: "category",
                dynamicPropsProvider: (context) => ({
                    [DescriptorProps.CATEGORY_CONFIGURED]: context.descriptor[DescriptorProps.CATEGORY_CONFIGURED],
                    additionalPropChange: (data) => context.baseHandleFieldChange(DescriptorProps.CATEGORY_CONFIGURED, data)
                }),
            }, CategoriesSectionField),
        new SelectFiedSpec(DescriptorProps.DATA_CALC_TYPE, {
            label: "Calculation Method for Calculated Reports",
            checkDisabled: ({ descriptor }) => DescriptorType.isHeadline(descriptor),
            validate: validateDataCalcType
        }, DATA_CALC_TYPES_MAP),
        new CheckboxFieldSpec(DescriptorProps.NOTE),
        new FormSection("Scale", [
            new CustomFieldSpec(DescriptorProps.INPUT_SCALE,
                {
                    checkDisabled: numFieldsDisabled,
                    validate: validateIScale,
                    customStaticProps: { number: true },
                    dynamicPropsProvider: (context) => ({
                        [DescriptorProps.VIEW_SCALE]: context.descriptor[DescriptorProps.VIEW_SCALE],
                        setViewScale: (data) => context.baseHandleFieldChange(DescriptorProps.VIEW_SCALE, data),
                        setScalable: (data) => context.baseHandleFieldChange(DescriptorProps.SCALABLE,data),
                    }),
                }, InputScaleSelectionField),
            new SelectFiedSpec(DescriptorProps.VIEW_SCALE,
                {
                    checkDisabled: numFieldsDisabled,
                    validate: validateVScale,
                    customStaticProps: { number: true }
                }, SCALE_MAP),
            new CheckboxFieldSpec(DescriptorProps.SCALABLE,
                {
                    checkDisabled: numFieldsDisabled,
                    validate: validationScalable
                }),
        ]),
        new SelectFiedSpec(DescriptorProps.STYLE, {
            label: "Background Color",
            onChangeAdapter: newVal => newVal === "inherit" ? {} : 
                { [CssProps.BACKGROUND_COLOR_PROP]: newVal },
            valueAdapter: val => Utils.normalizeBackgroundColor(val[CssProps.BACKGROUND_COLOR_PROP])
        }, DescriptorColors.ALL_AS_KV),
        new FormSection("Vertical Calculations", [
            getCalcFieldCfgSpec(DescriptorProps.CALCULATION,
                "Primary Calculation", primaryCalcDisabled, validatePrimaryCalc),
            getCalcFieldCfgSpec(DescriptorProps.SECONDARY_CALCULATION,
                "Secondary Calculation", secondaryCalcDisabled, validateSecondaryCalc)
        ]),
        new CustomFieldSpec(DescriptorProps.OUTGOING_BRIDGES, {
            dynamicPropsProvider: ({ outgoingBridges, availableBridgeEndDescriptors }) => ({
                value: outgoingBridges,
                availableDescriptors: availableBridgeEndDescriptors,
            }),
            validate: ({ outgoingBridges }) => outgoingBridgesSchema.safeParse(getOutgoingBridges(outgoingBridges)).success,
        }, OutgoingBridgesField),
    ]
}

class DescriptorsForm extends React.Component {

    static MODAL_INVALID_STATE = "Invalide state. Trying to open a new modal before closing the old one. Please do not save the data and contact the administrator."
    static DELETE_FIELD_CONFIRMATION = "The data associated with that field will be permantly lost if you delete the field. Are you sure that you want to delete it?"

    constructor(props) {
        super(props);
        this.flatDynamicDescriptors = Utils.flatDescriptors(this.props.descriptors, true)
        this.state = {
            modal: null,
            desctoptorStyles: [],
            categorizationRequired: isCategorizationRequired(this.flatDynamicDescriptors),
            standardizedLabelRequired: isStandardizedLabelRequired(this.flatDynamicDescriptors),
            standardizedLabels: []
        }
        this.closeModal = this.closeModal.bind(this);
        this.lastOpen = null;
        this.lastClose = null;
    }

    componentDidMount() {
        StandardizedLabelsRepo.listStandardizedLabels((response) => {
            if(response.status === RESPONSE_STATUS.SUCCESS) {
                this.setState({standardizedLabels: response.data})
            }
        })
    }

    componentDidUpdate(prevProps) {
        if (prevProps.descriptors !== this.props.descriptors) {
            this.flatDynamicDescriptors = Utils.flatDescriptors(this.props.descriptors, true)
            this.setState({
                categorizationRequired: isCategorizationRequired(this.flatDynamicDescriptors),
                standardizedLabelRequired: isStandardizedLabelRequired(this.flatDynamicDescriptors)
            })
        }
    }

    highlite(descriptorIds) {
        const desctoptorStyles = {}
        for (const id of descriptorIds) {
            desctoptorStyles[id] = { backgroundColor: "#fcfbc2" }
        }
        this.setState({ desctoptorStyles: desctoptorStyles })
    }

    validateOpenModalReq() {
        if (this.state.modal !== null) {
            Alert.error(`${DescriptorsForm.MODAL_INVALID_STATE}, lastOpen: ${this.lastOpen}, lastClose: ${this.lastClose}`)
        }
        this.lastOpen = Date.now()
    }

    openFieldModal(descriptor, flatDescriptors, onSave, descriptorCollection = []) {
        this.validateOpenModalReq()
        this.setState({
            modal: <FieldModal open={true}
                schemaId={this.props.schemaId}
                formSpec={FORM_SPEC}
                onSave={data => {
                    onSave(data)
                    this.closeModal()
                }}
                onCancel={this.closeModal}
                descriptors={this.props.descriptors}
                descriptorCollection={descriptorCollection}
                descriptor={descriptor}
                flatDescriptors={flatDescriptors} />
        })
    }

    openConfirmationModal(onConfirm) {
        this.validateOpenModalReq()
        this.setState({
            modal: <ConfirmationModal
                msg={DescriptorsForm.DELETE_FIELD_CONFIRMATION}
                onCancel={() => this.closeModal()}
                onConfirm={() => {
                    onConfirm()
                    this.closeModal()
                }} />
        })
    }

    openMoveToModal(field, targetDescriptors, onApply) {
        this.validateOpenModalReq()
        this.setState({
            modal: <MoveToModal
                targetDescriptors={targetDescriptors}
                field={field}
                onApply={(targetId) => {
                    onApply(targetId)
                    this.closeModal()
                }}
                onCancel={() => this.closeModal()}
            />
        })
    }


    openMoveBellowModal(descriptor, flatDescriptors, onApply) {
        this.validateOpenModalReq()
        this.setState({
            modal: <MoveBellowModal
                avalableDescriptors={flatDescriptors.filter(d => d.id !== descriptor.id)}
                descriptor={descriptor}
                onApply={(targetId) => {
                    onApply(targetId)
                    this.closeModal()
                }}
                onCancel={() => this.closeModal()}
            />
        })
    }

    closeModal() {
        this.lastClose = Date.now()
        this.setState({ modal: null })
    }

    getFieldItem(descriptor, subItems, optionsMap, flatDescriptors, categorizationRequired, bridges) {
        const editable = descriptor.editable && !this.props.readOnly

        const options = editable ? [
            new Option("Add Subfield", optionsMap.addSubfield),
            new Option("Move Up", optionsMap.moveUp),
            new Option("Move Down", optionsMap.moveDown),
            new Option("Move Bellow", optionsMap.moveBellow),
            new Option("Move To", optionsMap.moveTo),
            new Option("Remove", optionsMap.remove)]
            : (this.props.readOnly ? [] : [new Option("Move Up", optionsMap.moveUp),
            new Option("Move Down", optionsMap.moveDown)])

        return <SortableDescriptorItem
            id={descriptor.id}
            dragDisabled={this.props.readOnly}
            style={this.state.desctoptorStyles[descriptor.id] || {}}
            onDoubleClick={(e) => {
                e.stopPropagation();
                editable && optionsMap.update()
            }}
            className={"descriptorItem" + (editable ? " cursorPointer" : "")}
            key={descriptor.id}>
            {dragHandle => <>
                <DescriptorView
                    standardizedLabelRequired={this.state.standardizedLabelRequired}
                    standardizedLabel={this.state.standardizedLabels.find(a => a.id === String(descriptor[DescriptorProps.STANDARDIZED_LABEL_RELATION]?.standardizedLabelId))}
                    highlite={descriptorIds => this.highlite(descriptorIds)}
                    bridges={bridges}
                    descriptor={descriptor}
                    options={options}
                    additionalStyles={this.state.desctoptorStyles[descriptor.id] || {}}
                    dragHandle={dragHandle}
                    flatDescriptors={flatDescriptors}
                    categorizationRequired={categorizationRequired}
                    subItems={subItems} />
                {this.getDivider(optionsMap.add)}
            </>}
        </SortableDescriptorItem>
    }

    getDivider(onClick) {
        return this.props.readOnly ? <div className='crosshair inactiveCrosshair'><Divider /></div> :
            <div onClick={onClick} className="crosshair"><Divider /></div>
    }

    getFieldsList(descriptorOps, collection, parent, flatDescriptors, categorizationRequired, bridgesByDescriptorId) {
        const descriptors = collection.map((descriptor, idx) => {
            const descriptorId = descriptor.id

            const optionsMap = {
                "update": () =>
                    this.openFieldModal(descriptor, flatDescriptors, newField => descriptorOps.update(newField),
                        parent === "ROOT" ? collection : []),
                "moveUp": () => descriptorOps.moveUp(descriptorId),
                "moveDown": () => descriptorOps.moveDown(descriptorId),
                "moveBellow": () =>
                    this.openMoveBellowModal(descriptor, flatDescriptors,
                        targetDescriptorId => descriptorOps.moveBellow(descriptorId, targetDescriptorId)),
                "remove": () =>
                    this.openConfirmationModal(() => descriptorOps.remove(descriptorId)),
                "add": () => {
                    const newDescriptor = this.createDescriptor()
                    const descriptorCollection = parent === "ROOT"
                        ? [...collection.slice(0, idx + 1), newDescriptor, ...collection.slice(idx + 1)] : []
                    this.openFieldModal(newDescriptor, flatDescriptors,
                        newField => descriptorOps.add(parent, idx + 1, newField), descriptorCollection)
                },
                "addSubfield": () =>
                    this.openFieldModal(this.createDescriptor(), flatDescriptors, newField =>
                        descriptorOps.add(descriptorId, 0, newField))
            }

            const targetOps = descriptorOps.getTargetOptions(descriptorId)
            if (targetOps.length > 0) {
                optionsMap["moveTo"] = () => {
                    this.openMoveToModal(descriptor, targetOps,
                        targetFieldId => descriptorOps.moveTo(descriptorId, targetFieldId))
                }
            }

            const subItems = this.getFieldsList(descriptorOps, descriptor.subFields, descriptorId, flatDescriptors, categorizationRequired, bridgesByDescriptorId)

            return this.getFieldItem(descriptor, subItems, optionsMap, flatDescriptors, categorizationRequired, bridgesByDescriptorId.get(descriptor.id))
        })

        return <SortableDescriptorList
            ids={collection.map(d => d.id)}
            onMove={(id, newIdx) => descriptorOps.move(id, newIdx)}>
            <List verticalAlign='middle'>{descriptors}</List>
        </SortableDescriptorList>
    }

    createDescriptor() {
        const descriptor = new Descriptor()
        const scale = this.props[SchemaField.DEF_SCALE]
        descriptor[DescriptorProps.INPUT_SCALE] = scale
        descriptor[DescriptorProps.VIEW_SCALE] = scale
        descriptor[DescriptorProps.IMPORTANCE] = 5
        descriptor[DescriptorProps.DATA_CALC_TYPE] = this.props[SchemaField.DEF_DATA_CALC_TYPE]
        descriptor[DescriptorProps.TYPE] = ""
        descriptor[DescriptorProps.TIMEFRAME] = {
            referenceId: null,
            period: TIMEFRAME_PERIOD.REPORT_PERIOD,
        }

        return descriptor
    }

    render() {
        const descriptors = this.props.descriptors
        const bridgesByDescriptorId = getDescriptorBridges(descriptors)
        return (
            <>
                {this.state.modal}
                {descriptors.length > 0 &&
                    <>
                        <b>Model Fields</b>
                        <Segment className='descriptorFields'>
                            {this.getFieldsList(
                                new DescriptorOps(descriptors, this.props.onChange),
                                descriptors, "ROOT", Utils.flatDescriptors(descriptors,false,true), this.state.categorizationRequired, bridgesByDescriptorId)}
                        </Segment>
                    </>}
            </>
        );
    }

}


DescriptorsForm.propTypes = {

    /**
     * All schema descriptors.
     */
    descriptors: PropTypes.array.isRequired,

    /**
     * Func to be called if the descriptors are changed.
     */
    onChange: PropTypes.func.isRequired,

    /**
     * True if the descriptors are allowed for .
     */
    readOnly: PropTypes.bool.isRequired,

    /**
     * Default data calculation type. 
     */
    defaultDataCalcType: PropTypes.string.isRequired,

    /**
     * Default input and view scale. 
     */
    defaultScale: PropTypes.number.isRequired
}


export default DescriptorsForm


